import axios from "axios";
import { eventBus } from "@/main";

const moduleLab = {
  namespaced: true,
  state: {
    labExpenseList: [],
    labProductList: [],
    labCompanyList: [],
    labStatusHistory: [],
    isLoadingStatusHistory: false
  },
  mutations: {
    setLabExpenseList(state, data) {
      state.labExpenseList = data ? data : [];
    },
    setLabProductList(state, data) {
      state.labProductList = data ? data : [];
    },
    setLabCompanyList(state, data) {
      state.labCompanyList = data ? data : [];
    },

    setFavoriteLabProductList(state, data) {
      let index = state.labProductList.findIndex(function (event) {
        return event.id == data.id;
      });
      if (index >= 0) {
        state.labProductList[index].favorite = !data.favorite;
      }
    },
    updateLabItemStatus(state, { labId, status }) {
      let index = state.labExpenseList.findIndex(item => item.id === labId);
      if (index >= 0) {
        state.labExpenseList[index].status = status;
      }
    },
    setLabStatusHistory(state, data) {
      state.labStatusHistory = data || [];
    },
    setLoadingStatusHistory(state, isLoading) {
      state.isLoadingStatusHistory = isLoading;
    }
  },
  actions: {
    // Lab expense list
    fetchLabExpenseList({ commit }, payload) {
      return (
        axios
          .get(`/api/lab/${payload.clinicUrl}/${payload.branchUrl}`, {
            params: payload.event
          })
          // .post(
          //   `/api/lab/search/${payload.clinicUrl}/${payload.branchUrl}`,
          //   payload.event
          // )
          .then(res => {
            commit("setLabExpenseList", res.data);
            return res;
          })
          .catch(err => {
            // Automatic error handling via interceptor
            throw err;
          })
      );
    },
    fetchLabExpenseForReport({ commit }, payload) {
      return axios
        .get(`/api/lab/${payload.clinicUrl}/${payload.branchUrl}`, {
          params: payload.event
        })
        .then(res => {
          commit("setLabExpenseList", res.data);

          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    createLabExpenseItem({ commit }, payload) {
      return axios
        .post(
          `/api/lab/${payload.clinicUrl}/${payload.branchUrl}`,
          payload.event
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    updateLabExpenseItem({ commit }, payload) {
      const id = payload.event.id;
      delete payload.event.id;
      return axios
        .put(
          `/api/lab/${payload.clinicUrl}/${payload.branchUrl}/${id}`,
          payload.event
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    deleteLabExpenseItem({ commit }, payload) {
      return axios
        .delete(
          `/api/lab/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },

    // Lab Status
    updateLabStatus({ commit }, payload) {
      return axios
        .put(
          `/api/lab/${payload.clinicUrl}/${payload.branchUrl}/${payload.labId}/status`,
          {
            status: payload.status
          }
        )
        .then(res => {
          commit("updateLabItemStatus", { labId: payload.labId, status: payload.status });
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    fetchLabStatusHistory({ commit }, payload) {
      commit("setLoadingStatusHistory", true);
      return axios
        .get(
          `/api/lab/${payload.clinicUrl}/${payload.branchUrl}/${payload.labId}/status/history`
        )
        .then(res => {
          commit("setLabStatusHistory", res.data);
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        })
        .finally(() => {
          commit("setLoadingStatusHistory", false);
        });
    },

    //Lab Product
    fetchLabProductList({ commit }, payload) {
      return axios
        .get(`/api/master/lab/${payload.clinicUrl}/${payload.branchUrl}`)
        .then(res => {
          commit("setLabProductList", res.data);
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    fetchLabProductById({ commit }, payload) {
      return axios
        .get(
          `/api/master/lab/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    addLabProductFavorite({ commit }, payload) {
      return axios
        .post(
          `/api/master/labFav/${payload.clinicUrl}/${payload.branchUrl}/${payload.event.id}`
        )
        .then(res => {
          commit("setFavoriteLabProductList", payload.event);
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    deleteLabProductFavorite({ commit }, payload) {
      return axios
        .delete(
          `/api/master/labFav/${payload.clinicUrl}/${payload.branchUrl}/${payload.event.id}`
        )
        .then(res => {
          commit("setFavoriteLabProductList", payload.event);
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    deleteLabProduct({ commit }, payload) {
      return axios
        .delete(
          `/api/master/lab/${payload.clinicUrl}/${payload.branchUrl}/${payload.event.id}`
        )
        .then(res => {
          // commit("setLabProductList", res.data);
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },

    createLabProduct({ commit }, payload) {
      return axios
        .post(
          `/api/master/lab/${payload.clinicUrl}/${payload.branchUrl}`,
          payload.event
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    updateLabProduct({ commit }, payload) {
      let event = { ...payload.event };
      delete event.id;
      return axios
        .put(
          `/api/master/lab/${payload.clinicUrl}/${payload.branchUrl}/${payload.event.id}`,
          event
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },

    //Lab company
    fetchLabCompanyList({ commit }, payload) {
      return axios
        .get(`/api/master/companyLab/${payload.clinicUrl}/${payload.branchUrl}`)
        .then(res => {
          commit("setLabCompanyList", res.data);
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    createLabCompany({ commit }, payload) {
      return axios
        .post(
          `/api/master/companyLab/${payload.clinicUrl}/${payload.branchUrl}`,
          payload.event
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    editLabCompany({ commit }, payload) {
      // update ทั้ง list เลย
    },
    checkLabCompany({ commit }, payload) {
      // เช็คว่า company ถูก assign กับ Labproduct อยู่หรือไม่ ถ้าได้ assign ถึงจะลบได้
    },
    deleteLabCompanyitem({ commit }, payload) {
      return axios
        .delete(
          `/api/master/companyLab/${payload.clinicUrl}/${payload.branchUrl}/${payload.event.id}`
        )
        .then(res => {
          // commit("deleteQueueAppointment", payload.event.id);
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    }
  },
  getters: {
    getLabExpenseList: state => {
      return state.labExpenseList.filter(i => !i.cancelDt);
    },
    getLabProductList: state => {
      return state.labProductList;
    },
    getGroupedLabProdList: (state, getters) => {
      //favorite group
      const favGroup = [
        {
          category: "ผลิตภัณฑ์ใช้ประจำ",
          libs: []
        }
      ];
      getters.getLabProductList
        .filter(item => item.favorite == true)
        .forEach(item => {
          favGroup[0].libs.push(item);
        });
      // grouped by category

      const labProd = [
        { category: "ผลิตภัณฑ์แลป", libs: getters.getLabProductList }
      ];

      return favGroup.concat(labProd);
    },

    getLabCompanyList: state => {
      return state.labCompanyList;
    },

    getLabCompanyBy: (state, getters) => (value, key) => {
      return getters.findBy(state.labCompanyList, value, key, {}) || {};
    },
    findBy: () => (dataList, value, key, defaultVal) => {
      if (!value) {
        return defaultVal;
      }
      return dataList.find(function (item) {
        return item[key] == value;
      });
    },
    getLabStatusHistory: state => {
      return state.labStatusHistory;
    },
    isLoadingStatusHistory: state => {
      return state.isLoadingStatusHistory;
    }
  }
};
export default moduleLab;
